import { Injectable, inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { TranslatedLabelDto } from './_stubs/language/translatedLabelDto';
import { WorkShopAdminModel } from '../typescript/workShopAdminModel';
import { TyreDelivery } from '../typescript/tyreDelivery';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserRole } from '../typescript/userRole';
import { Nationality } from '../typescript/nationality';
import { TranslateService } from '@ngx-translate/core';
import { NationalityHandlerService } from '../shared/services/nationalityHandler.service';

@Injectable({
  providedIn: 'root',
})
export class Globals {
  deviceService = inject(DeviceDetectorService);
  private translateService = inject(TranslateService);
  nationalityHandler = inject(NationalityHandlerService);

  baseUrl = this.getEnforcedBaseUrl();
  version = '1.0.0';

  projectName = 'Core';
  actualLanguage = 'en';
  downloadedLanguage: TranslatedLabelDto[] = [];
  contentcount = 0;
  countVehicle = 0;

  DEBUG_MODE = false;
  isIE = this.deviceService.browser() === 'IE';
  isChrome = this.deviceService.browser() === 'Chrome';
  KEY_TOKEN = 'admin_token';
  KEY_USER = 'user';
  KEY_SHOP = 'workshop';
  KEY_ROLE = 'role';
  KEY_SHOPIDS = 'workshopids';
  KEY_INSITEACCESS = 'insite_access';
  loginUrl = '/login';
  isFirefox: boolean;
  SELECTED_WORKSHOP: WorkShopAdminModel; //workshopObject
  tyreDelivery = TyreDelivery;
  //emailValidationPattern = "([a-zA-Z0-9]+)([_.-{1}])?([a-zA-Z0-9]+)@([a-zA-Z0-9]+)([.])([a-zA-Z.]+)";
  constructor() {
    this.isFirefox = this.deviceService.browser() === 'Firefox';
  }
  addTranslatedLabel(label: TranslatedLabelDto, languageCode: string) {
    if (languageCode !== this.actualLanguage) {
      return;
    }
    const existingTranslatedLabel = this.downloadedLanguage.find((a) => a.labelId === label.labelId);

    if (existingTranslatedLabel !== null) {
      existingTranslatedLabel.value = label.value;
    } else {
      this.downloadedLanguage.push(label);
    }
  }

  /*validateEmail(email: string) {
      return new RegExp(this.emailValidationPattern).test(email)
  }*/

  public getRole(): UserRole[] {
    if (localStorage.getItem(this.KEY_ROLE) && localStorage.getItem(this.KEY_ROLE).length === 1) {
      return [JSON.parse(localStorage.getItem(this.KEY_ROLE))];
    }
    if (!localStorage.getItem(this.KEY_ROLE) || localStorage.getItem(this.KEY_ROLE).length === 0) {
      return [];
    }
    return JSON.parse(localStorage.getItem(this.KEY_ROLE)) as UserRole[];
  }

  public getShop() {
    return JSON.parse(localStorage.getItem(this.KEY_SHOP)) as WorkShopAdminModel;
  }

  public getHeaders(forced?: boolean) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    if (localStorage.getItem(this.KEY_TOKEN) && localStorage.getItem(this.KEY_TOKEN).length !== 0) {
      headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    }
    if (localStorage.getItem('workshop')) {
      headers = headers.append('x-workShopId', localStorage.getItem('workshop'));
    }
    if (forced) {
      headers = headers.append('x-force', 'true');
    }

    headers = headers.append('Accept-Language', this.getLang());
    return headers;
  }

  public getMagicHeaders(isSA) {
    let headers = new HttpHeaders();
    headers = headers.append('x-workShopId', localStorage.getItem('workshop'));

    headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    headers = headers.append('Accept-Language', this.getLang());
    return headers;
  }
  public getExcelHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    headers = headers.append('x-workShopId', localStorage.getItem('workshop'));

    headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    headers = headers.append('Accept-Language', this.getLang());
    return headers;
  }
  public getSAHeaders(notToSendWSId = true, forced = false, fromTyrehotel = false) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    if (localStorage.getItem(this.KEY_TOKEN) && localStorage.getItem(this.KEY_TOKEN).length !== 0) {
      headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    }
    if (
      localStorage.getItem('workshop') !== null &&
      localStorage.getItem('workshop') !== 'null' &&
      notToSendWSId === true
    ) {
      headers = headers.append('x-workShopId', localStorage.getItem('workshop'));
    }
    if (forced) {
      headers = headers.append('x-force', 'true');
    }

    if (fromTyrehotel) {
      headers = headers.append('x-customerNoteOnly', 'true');
    }

    headers = headers.append('Accept-Language', this.getLang());

    return headers;
  }
  public getWorkshopHeaders(notToSendWSId = true, forced = false, id) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    if (localStorage.getItem(this.KEY_TOKEN) && localStorage.getItem(this.KEY_TOKEN).length !== 0) {
      headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    }

    headers = headers.append('x-workShopId', id);

    if (forced) {
      headers = headers.append('x-force', 'true');
    }

    headers = headers.append('Accept-Language', this.getLang());

    return headers;
  }

  public getMagicHeader(id) {
    return this.getSAHeaders().delete('x-workShopId').set('x-workShopId', id);
  }

  public getImageHeaders() {
    let headers = new HttpHeaders();
    // headers = headers.append("Content-Type", 'multipart/form-data');
    if (localStorage.getItem(this.KEY_TOKEN) && localStorage.getItem(this.KEY_TOKEN).length !== 0) {
      headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    }
    headers = headers.append('x-workShopId', localStorage.getItem('workshop'));

    headers = headers.append('Accept-Language', this.getLang());
    headers = headers.append('Cache-Control', 'max-age=86400');
    return headers;
  }
  public getImageWithXforce(id) {
    let headers = new HttpHeaders();
    // headers = headers.append("Content-Type", 'multipart/form-data');
    if (localStorage.getItem(this.KEY_TOKEN) && localStorage.getItem(this.KEY_TOKEN).length !== 0) {
      headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    }
    headers = headers.append('x-workShopId', String(id));

    headers = headers.append('Accept-Language', this.getLang());
    headers = headers.append('Cache-Control', 'max-age=86400');

    return headers;
  }

  public getRAHeaders(param) {
    let headers = new HttpHeaders();
    if (localStorage.getItem(this.KEY_TOKEN) && localStorage.getItem(this.KEY_TOKEN).length !== 0) {
      headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem(this.KEY_TOKEN));
    }
    headers = headers.append('x-workShopId', localStorage.getItem('workshop'));

    if (param) {
      headers = headers.append('x-force', 'true');
    } else {
      headers = headers.append('x-force', 'false');
    }
    headers = headers.append('Accept-Language', this.getLang());
    return headers;
  }

  getEnforcedBaseUrl() {
    let url = '';
    if (location.toString().includes('http://localhost:4200') || location.toString().includes('192.168')) {
      url = 'https://bd-tst.4dsoft.hu/';
    } else {
      url = location.origin + '/';
    }

    return url;
  }

  getLang() {
    return localStorage.getItem('lang') ? localStorage.getItem('lang') : navigator.language;
  }

  capitalize(s) {
    if (typeof s !== 'string') {
      return '';
    }
    return s.charAt(0) + s.toLowerCase().slice(1);
  }

  public getBrowser() {
    return this.deviceService.browser();
  }
  public shortNatStringByNationality(nationality) {
    switch (nationality) {
      case Nationality.HUNGARIAN:
        return 'hu';
      case Nationality.SLOVAKIAN:
        return 'sk';
      case Nationality.ENGLISH:
        return 'gb';
    }
  }

  public createQueryString(filter) {
    let url = '?';
    for (const key in filter) {
      if (filter[key] !== null) {
        if (Array.isArray(filter[key])) {
          for (const arraykey in filter[key]) {
            if (url.length > 0) {
              url += `&${key}=${filter[key][arraykey]}`;
            } else {
              url += `${key}=${filter[key][arraykey]}`;
            }
          }
        } else if (typeof filter[key] !== 'function' && typeof filter[key] !== 'object') {
          url += key + '=' + filter[key] + '&';
        }
      }
    }
    return url;
  }
  getEnumKeyByEnumValue(myEnum: any, enumValue: number | string) {
    const keys = Object.keys(myEnum).filter((x) => myEnum[x] === enumValue);
    return keys.length > 0 ? keys[0] : '';
  }

  public addMonths(date, months) {
    const currentDate = new Date(date);
    currentDate.setMonth(currentDate.getMonth() + months);
    return currentDate;
  }

  public isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

  public generateCustomerName(customer): string {
    let customerFormattedName = '';
    if (customer && customer.customerDeleteDate === null) {
      if (!(customer as any).customerName) {
        customerFormattedName += `${customer.lastName} ${customer.firstName}`;
      } else {
        customerFormattedName += `${(customer as any).customerName}`;
      }
    } else if (customer) {
      customerFormattedName = this.translateService.instant('DeletedUser');
    }
    return customerFormattedName;
  }
  public generateCustomerPhone(customer): string {
    let customerFormattedPhone = '';
    if (customer && customer.customerDeleteDate === null) {
      customerFormattedPhone = customer.phoneNumber;
    } else if (customer) {
      customerFormattedPhone = this.translateService.instant('DeletedPhone');
    }
    return customerFormattedPhone;
  }
  public generateCustomerEmail(customer): string {
    let customerFormattedEmail = '';
    if (customer && customer.customerDeleteDate === null) {
      customerFormattedEmail = customer.email;
    } else if (customer) {
      customerFormattedEmail = this.translateService.instant('DeletedEmail');
    }
    return customerFormattedEmail;
  }

  public returnNationalitiesWithoutEnglish() {
    return Nationality.values().filter((x) => x !== Nationality[Nationality.ENGLISH]);
  }
}
